class NSSPressQuotes extends HTMLElement {

  constructor() {
    super();

    this.debug = false;

    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Press Quotes] Connected.");

    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: true,
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 20,
      effect: "fade",

      breakpoints: {
        414: {
          slidesPerView: 1,
        },
        750: {
          slidesPerView: 1,
        },
        990: {
          slidesPerView: 1,
        },
      },

      a11y: {
        enabled: true,
      },

      pagination: {
        el: '.nss-press-quotes-pagination',
        clickable: true,
      },

      on: {
        realIndexChange: () => {
          this.handleChange(this.swiper.realIndex);
        }
      },
    });

    const logoEls = this.querySelectorAll(`[nss-press-index]`);
    logoEls.forEach((logoEl) => {
      logoEl.addEventListener(`mouseenter`, this.handleHover.bind(this));
    });

    const editorEvents = [
      `shopify:inspector:activate`,
      `shopify:inspector:deactivate`,
      `shopify:section:load`,
      `shopify:section:unload`,
      `shopify:section:select`,
      `shopify:section:deselect`,
      `shopify:section:reorder`,
      `shopify:block:select`,
      `shopify:block:deselect`,
    ]
    editorEvents.forEach((event) => {
      this.addEventListener(event, this.handleEditorEvent.bind(this));
    });
  }

  handleEditorEvent(e) {
    if (this.debug) console.log("[NSS][Press Quotes] Handle editor event, e:", e);

    switch(e.type) {

      case `shopify:block:select`:
        const blockEl = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        const slideEl = blockEl.closest(`.swiper-slide`);
        if (this.debug) console.log("[NSS][Press Quotes] slideEl:", slideEl);
        if (slideEl) {
          // const index = slideEl.getAttribute(`data-swiper-slide-index`);
          const slideEls = [...this.querySelectorAll(`.swiper-slide`)];
          const index = slideEls.indexOf(slideEl);
          if (this.debug) console.log("[NSS][Press Quotes] Sliding to index:", index);
          this.swiper.slideTo(index);
        }
        break;

    }
  }

  handleChange(index) {
    const activeEls = this.querySelectorAll(`.nss-active`);
    activeEls.forEach((activeEl) => {
      activeEl.classList.remove(`nss-active`)
    });
    const indexLogoEl = this.querySelector(`[nss-press-index="${index}"]`);
    indexLogoEl.classList.add(`nss-active`);
  }

  handleHover(e) {
    const index = e.target.getAttribute(`nss-press-index`);
    this.swiper.slideTo(index);
  }
}

let elementName = `nss-press-quotes`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSPressQuotes);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`)
}